import React, { useState } from "react";
import "./index.scss";
import BG from "../../assets/images/headerImages/headerBG.png";
import HeaderBG from "../../assets/images/header-bg.png";
import logo from "../../assets/images/logo-new.png";
import ZibuImg from "../../assets/images/headerImages/zibuImg.png";
import BtnIcon from "../../assets/images/headerImages/iconBtn.png";
import TabletBtnMenuBG from "../../assets/images/headerImages/menu-btn-bg.png";
import TabletLogo from "../../assets/images/headerImages/tablet-logo.png";
import MobileHeaderBG from "../../assets/images/headerImages/mobile-header.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Header = ({ menuOpen, toggleMenu }) => {
  return (
    <div className="header">
      <img
        className="menu-btn-bg tablet"
        src={TabletBtnMenuBG}
        alt="menu-btn-bg"
      />
      <img className="tablet-logo-bg tablet" src={logo} alt="tablet-logo-bg" />
      <img
        className="mobile-head-bg mobile"
        src={MobileHeaderBG}
        alt="mobile-head-bg"
      />
      <div className="header-wrap">
        <HashLink className="header-wrap-menuBtn" to={"/#adventures"}>
          About
        </HashLink>
        <img className="header-wrap-zibuIcon" src={logo} alt="zibuImg" />
        {/*<img className='header-wrap-headerBG' src={BG} alt='background'/>*/}
        <img className="header-wrap-headerBG" src={HeaderBG} alt="background" />
      </div>
      <div className="header-btnWrap">
        <a
          className="header-btnWrap-btn"
          href="#"
          target="_blank"
          onClick={(e) => {
            e.preventDefault();
            window.open(
              "mailto:heyzibu@cloudboxstudio.com",
              "popup",
              "width=560,height=340,left=50%,top=50%,toolbar=0,menubar=0,location=0"
            );
            if (window.focus) {
              window.focus();
            }
          }}
        >
          <div className="header-btnWrap-btn-text">contact</div>
          <img
            className="header-btnWrap-btn-icon"
            src={BtnIcon}
            alt="btnIcon"
          />
        </a>
      </div>
    </div>
  );
};

export default Header;
